import React, { useEffect, useState } from "react";
import AppsChart from "./AppsChart";
import ListAppCard from "./ListAppCard";
import ScreensChart from "./ScreensChart";
import { Divider } from "antd";

const MonitorMain = ({
  monitorData,
  updateVideoTrack,
  windowsSusAppData,
  macSusAppData,
}) => {
  const isWindows = monitorData?.some((point) =>
    point?.applicationNames?.some((app) =>
      app?.name?.toLowerCase().endsWith(".exe"),
    ),
  );
  const osType = isWindows ? "WINDOWS" : "MAC_OS";
  // console.log("Monitor Data:", monitorData);
  // console.log("Windows Suspicious Apps:", windowsSusAppData);
  // console.log("Mac Suspicious Apps:", macSusAppData);

  const [uniqueApps, setUniqueApps] = useState([]);

  const updateUniqueApps = (data) => {
    const appMap = new Map();

    data.forEach((snapshot) => {
      snapshot.applicationNames.forEach((app) => {
        if (!appMap.has(app.name)) {
          appMap.set(app.name, app);
        }
      });
    });

    setUniqueApps(Array.from(appMap.values()));
  };

  useEffect(() => {
    if (monitorData?.length > 0) {
      updateUniqueApps(monitorData);
    }
  }, [monitorData]);

  return (
    <div className="mt-[3.5rem] flex flex-col gap-10">
      <AppsChart
        dataPoints={monitorData}
        updateVideoTrack={updateVideoTrack}
        osType={osType}
        windowsSusAppData={windowsSusAppData}
        macSusAppData={macSusAppData}
      />
      <Divider className="border-gray-200 mt-1 mb-0" />
      <ScreensChart
        dataPoints={monitorData}
        updateVideoTrack={updateVideoTrack}
      />
      <Divider className="border-gray-200 mt-1 mb-0" />

      <ListAppCard
        uniqueApps={uniqueApps}
        isWindows={isWindows}
        windowsSusAppData={windowsSusAppData}
        macSusAppData={macSusAppData}
      />
    </div>
  );
};

export default MonitorMain;
